import http from "../http-common";

const normalizeString = (value) => String(value || "").trim();

const buildSearchPayload = (query = {}) => {
  // Support multiple possible input fields and ensure minimum values
  const rawPage = query.pageNumber !== undefined ? query.pageNumber : (query.page !== undefined ? query.page : (query.p !== undefined ? query.p : 1));
  let page = Number(rawPage);
  if (!Number.isFinite(page) || page < 1) page = 1;

  const rawLimit = query.maxPageItem !== undefined ? query.maxPageItem : (query.limit !== undefined ? query.limit : 10);
  let limit = Number(rawLimit);
  if (!Number.isFinite(limit) || limit < 1) limit = 10;

  return {
    itemCode: normalizeString(query.itemCode !== undefined ? query.itemCode : query.productCode),
    itemName: normalizeString(query.itemName),
    pageNumber: page,
    maxPageItem: limit,
  };
};

const buildTaxPercentage = (data = {}) => {
  const taxValue = data.taxPercentage;

  if (taxValue === undefined || taxValue === null || String(taxValue).trim() === "") {
    return "";
  }

  if (String(taxValue) === "other") {
    return normalizeString(data.taxPercentageInput);
  }

  return normalizeString(taxValue);
};

const buildRequestPayload = (data = {}, includeItemCode = false) => {
  const payload = {
    itemName: normalizeString(data.itemName),
    itemNote: normalizeString(data.itemNote),
    quantity:
      data.quantity !== undefined &&
      data.quantity !== null &&
      String(data.quantity).trim() !== ""
        ? Number(data.quantity)
        : 1,
    unitPrice:
      data.unitPrice !== undefined &&
      data.unitPrice !== null &&
      String(data.unitPrice).trim() !== ""
        ? Number(data.unitPrice)
        : 0,
    taxPercentage: buildTaxPercentage(data),
    unitName: normalizeString(data.unitName),
    schoolId: data.schoolId !== undefined ? data.schoolId : null,
  };

  if (includeItemCode) {
    payload.itemCode = normalizeString(
      data.itemCode !== undefined ? data.itemCode : data.productCode
    );
  }

  return payload;
};

class SinvoiceGoodsItemService {
  /**
   * Tìm kiếm / lọc danh sách hàng hóa, dịch vụ (phân trang)
   * @param {Object} query
   * @param {string} query.itemCode - Tìm theo mã hàng hóa
   * @param {string} query.itemName - Tìm theo tên hàng hóa
   * @param {number} query.page - Trang hiện tại (1-based)
   * @param {number} query.limit - Số bản ghi mỗi trang
   */
  searchGoodsItems(query = {}) {
    const params = buildSearchPayload(query);
    return http.get(`/sinvoice/invoice-item/search`, { params });
  }

  /**
   * Lấy toàn bộ hàng hóa/dịch vụ cho một trường (full list) - giả sử BE có endpoint trả full
   * @param {Object|number|string} opts - Có thể truyền schoolId trực tiếp hoặc object { schoolId }
   */
  getAllGoodsItems() {
    return http.get(`/sinvoice/invoice-item/all`);
  }

  /**
   * Lấy chi tiết một hàng hóa, dịch vụ theo ID
   * @param {number|string} id
   */
  getGoodsItemDetail(id) {
    return http.get(`/sinvoice/invoice-item/${id}`);
  }

  /**
   * Tạo mới hàng hóa, dịch vụ
   * Mã hàng hóa (productCode) do BE tự sinh, không gửi lên
   * @param {Object} data - Thông tin hàng hóa
   * @param {string} data.itemName - Tên hàng hóa
   * @param {number} data.unitPrice - Đơn giá
   * @param {string} data.unitName - Đơn vị tính
   * @param {number|string} data.taxPercentage - Thuế GTGT
   * @param {number|null} data.taxPercentageInput - Thuế GTGT tùy chỉnh (khi taxPercentage = 'other')
   * @param {string} data.itemNote - Ghi chú
   */
  createGoodsItem(data) {
    return http.post(`/sinvoice/invoice-item`, buildRequestPayload(data));
  }

  /**
   * Cập nhật hàng hóa, dịch vụ
   * @param {number|string} id
   * @param {Object} data
   */
  updateGoodsItem(id, data) {
    return http.put(`/sinvoice/invoice-item/${id}`, buildRequestPayload(data, true));
  }

  /**
   * Xóa hàng hóa, dịch vụ
   * @param {number|string} id
   */
  deleteGoodsItem(id) {
    return http.delete(`/sinvoice/invoice-item/${id}`);
  }
}

export default new SinvoiceGoodsItemService();

